import React, { useState, useEffect } from "react";
import "./App.css";

const BOARD_SIZE = 20;
const INITIAL_SNAKE = [{ x: 10, y: 20 }, {x:10, y:21}];
const INITIAL_DIRECTION = { x: 0, y: 1 };
const SNAKE_SPEED = 200; // Speed of the snake in milliseconds

function App() {
  const [snake, setSnake] = useState(INITIAL_SNAKE);
  const [food, setFood] = useState(generateFood());
  const [direction, setDirection] = useState(INITIAL_DIRECTION);
  const [gameOver, setGameOver] = useState(false);
  const [canChangeDirection, setCanChangeDirection] = useState(true);
  const [score, setScore] = useState(0); // Initialize score to 0

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!canChangeDirection) return;

      switch (event.key) {
        case "ArrowUp":
          changeDirection({ x: 0, y: -1 });
          break;
        case "ArrowDown":
          changeDirection({ x: 0, y: 1 });
          break;
        case "ArrowLeft":
          changeDirection({ x: -1, y: 0 });
          break;
        case "ArrowRight":
          changeDirection({ x: 1, y: 0 });
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [direction, canChangeDirection]);

  useEffect(() => {
    if (gameOver) return;

    const intervalId = setInterval(() => {
      moveSnake();
    }, SNAKE_SPEED);

    return () => clearInterval(intervalId);
  }, [snake, direction, gameOver]);

  function generateFood() {
    return {
      x: Math.floor(Math.random() * BOARD_SIZE),
      y: Math.floor(Math.random() * BOARD_SIZE),
    };
  }

  function moveSnake() {
    const newHead = {
      x: (snake[0].x + direction.x + BOARD_SIZE) % BOARD_SIZE,
      y: (snake[0].y + direction.y + BOARD_SIZE) % BOARD_SIZE,
    };
    

    // Check for collision with the snake body
    if (snake.some((segment) => segment.x === newHead.x && segment.y === newHead.y)) {
      setGameOver(true);
      return;
    }

    const newSnake = [newHead, ...snake];

    console.log(newSnake)
    // Check if the snake eats food
    if (newHead.x === food.x && newHead.y === food.y) {
      setFood(generateFood());
      setScore(score + 1); // Increment score by 1
    } else {
      newSnake.pop();
    }

    setSnake(newSnake);
    setCanChangeDirection(true); // Allow direction changes after the snake moves
  }

  function resetGame() {
    setSnake(INITIAL_SNAKE);
    setDirection(INITIAL_DIRECTION);
    setFood(generateFood());
    setGameOver(false);
    setScore(0); // Reset the score
    setCanChangeDirection(true);
  }

  function changeDirection(newDirection) {
    // Prevent reversing direction
    if (
      (newDirection.x === -direction.x && newDirection.y === -direction.y) ||
      (newDirection.x === direction.x && newDirection.y === direction.y)
    ) {
      return;
    }

    setDirection(newDirection);
    setCanChangeDirection(false); // Disable further direction changes until the snake moves
  }

  return (
    <div className="App">
      <h1>Snake Saga</h1>
      <h2>Score: {score}</h2> {/* Display the score */}
      {gameOver ? (
        <div>
          <h2>Game Over</h2>
          <p>Your Final Score: {score}</p>
          <button onClick={resetGame}>Restart</button>
        </div>
      ) : (
        <>
          <div
            className="board"
            style={{
              gridTemplateRows: `repeat(${BOARD_SIZE}, 1fr)`,
              gridTemplateColumns: `repeat(${BOARD_SIZE}, 1fr)`,
            }}
          >
            {Array.from({ length: BOARD_SIZE }).map((_, row) =>
              Array.from({ length: BOARD_SIZE }).map((_, col) => {
                const isSnake = snake.some((segment) => segment.x === col && segment.y === row);
                const isFood = food.x === col && food.y === row;
                return (
                  <div
                    key={`${row}-${col}`}
                    className={`cell ${isSnake ? "snake" : ""} ${isFood ? "food" : ""}`}
                  ></div>
                );
              })
            )}
          </div>
          <div className="controls">
            <button onClick={() => changeDirection({ x: 0, y: -1 })}>Up</button>
            <div>
              <button onClick={() => changeDirection({ x: -1, y: 0 })}>Left</button>
              <button onClick={() => changeDirection({ x: 1, y: 0 })}>Right</button>
            </div>
            <button onClick={() => changeDirection({ x: 0, y: 1 })}>Down</button>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
